import HTTP from "../http";
import Jsona from "jsona";
import moment from "@/utils/moment";
import accountableHelper from "@/api/helpers/accountable";

const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/legals?include=account,account.profile&page[number]=${page}&sort=${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os clientes!";
    }
  },

  async getAddresses(id) {
    try {
      let results = await HTTP.normal.get(
        `/legals/${id}?include=addresses.district.city.state.country,addresses.district.pricing`
      );
      results = dataFormatter.deserialize(results.data);
      return results.addresses;
    } catch (e) {
      throw "Ocorreu um erro ao buscar os endereços do cliente!";
    }
  },

  async create(payload) {
    try {
      let data = accountableHelper.buildLegalRequestBody(payload);
      const user = await HTTP.normal.post(`/legals`, data);
      return dataFormatter.deserialize(user.data);
    } catch ({ response: { data, status } }) {
      throw status === 422
        ? {
            status,
            message: "Verifique os dados informados e tente novamente!",
            data: data
          }
        : {
            status,
            message: "Ocorreu um erro inesperado ao criar o seu usuário!",
            data: []
          };
    }
  },

  async createPaymentGatewayAccount(payload) {
    try {
      let address = {
        street: payload.address.street,
        street_number: payload.address.street_number,
        zip_code: payload.address.zip_code,
        complement: payload.address.complement,
        district: payload.address.district.display_name,
        city: payload.address.district.city.display_name,
        state: payload.address.district.city.state.code,
        country: payload.address.district.city.state.country.code
      };

      let phone = {
        country_code: payload.phones[0].country_code,
        area_code: payload.phones[0].area_code,
        number: payload.phones[0].number
      };

      let data = {
        data: {
          type: "payment_gateway_accounts",
          attributes: {
            name: payload.accountable.company_name,
            alt_name: payload.accountable.business_name,
            document_type: "CNPJ",
            document_number: payload.accountable.cnpj,
            phone,
            address
          },
          relationships: {
            account: {
              data: {
                type: "accounts",
                id: payload.id
              }
            }
          }
        }
      };

      await HTTP.normal.post("/payment-gateway-accounts", data);
    } catch (e) {
      throw e;
      // throw "Ocorreu um erro ao criar o cliente no meio de pagamento, contate nosso suporte!";
    }
  },

  async createPaymentGatewayCustomer(payload) {
    try {
      let address = {
        street: payload.address.street,
        street_number: payload.address.street_number,
        zip_code: payload.address.zip_code,
        complement: payload.address.complement,
        district: payload.address.district.display_name,
        city: payload.address.district.city.display_name,
        state: payload.address.district.city.state.code,
        country: payload.address.district.city.state.country.code
      };

      let phone = {
        country_code: payload.phones[0].country_code,
        area_code: payload.phones[0].area_code,
        number: payload.phones[0].number
      };

      let data = {
        data: {
          type: "payment_gateway_customers",
          attributes: {
            document_type: "CNPJ",
            document_number: payload.accountable.cnpj,
            email: payload.email,
            fullname: payload.accountable.business_name,
            birthdate: moment(payload.profile.birthdate).format("Y-MM-DD"),
            phone,
            address
          },
          relationships: {
            customer: {
              data: {
                type: "legals",
                id: payload.accountable.id
              }
            }
          }
        }
      };

      await HTTP.normal.post("/payment-gateway-customers", data);
    } catch (e) {
      throw e;
      // throw "Ocorreu um erro ao criar o cliente no meio de pagamento, contate nosso suporte!";
    }
  },

  async createOnGateway(account_id) {
    try {
      let data = {
        data: {
          attributes: {
            account_id
          }
        }
      };

      await HTTP.withAccept.post(
        "/payment-gateway-accounts/create-on-gateway",
        data
      );
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/legals.js